import { Col, H1, H2, H3, H5, P, Row, Section, Wrapper } from '@ahmdigital/ui';
import { map } from 'lodash/fp';
import Icon from '@ahmdigital/icons-web';
import styled from 'styled-components';

import constants from '../../../../ahm-constants';
import getTravelInsuranceConstants from '../../../../utils/get-travel-insurance-constants';
import Head from '../../../../../utils/head';
import InsuranceSection from '../../../insurance/components/section';
import LegacyBorderedWrapper from '../../../../components/legacy-bordered-wrapper';
import Nav from '../../../../elements/nav';
import SmallDisclaimer from '../small-disclaimer';
import styles from './styles.module.sass';
import uncapFpIterator from '../../../../../utils/uncap-fp-iterator';

const handyLinksItems = [
  { name: 'Make a claim', url: constants.URLS.SALES.TRAVEL_INSURANCE_MAKE_A_CLAIM },
  { inNewTab: true, name: 'Manage your policy', url: constants.URLS.THIRD_PARTY.TRAVEL_INSURANCE_SSP },
  { inNewTab: true, name: 'Forms and guides', url: constants.URLS.SALES.TRAVEL_FORMS_AND_GUIDES },
  { name: 'Get a quote', url: constants.URLS.SALES.TRAVEL_INSURANCE },
];

const StyledNav = styled(Nav)`
  border: 1px solid ${({ theme }) => theme.colors.grey20};

  & nav > ul > li {
    border-bottom: 1px solid ${({ theme }) => theme.colors.grey10} !important;
    text-underline-offset: 3px;

    &:last-child {
      border-bottom: 0 !important;
    }
  }
`;

const TRAVEL_CONTACT_META_TITLE = 'Contact Us - ahm Travel Insurance';

const TravelInsuranceContactUs = () => {
  const { CONTACT } = getTravelInsuranceConstants();
  return (
    <LegacyBorderedWrapper>
      <Head>
        <title>Contact us - travel insurance</title>
        <meta name="description" content="Contact us - travel insurance" />
        <meta name="og:title" content={TRAVEL_CONTACT_META_TITLE} />
        <meta name="twitter:title" content={TRAVEL_CONTACT_META_TITLE} />
      </Head>
      <Section theme="black" variant="large">
        <Wrapper>
          <H1>travel insurance</H1>
        </Wrapper>
      </Section>
      <Section variant={[styles.introBlock, 'large']}>
        <Wrapper className={styles.content}>
          <InsuranceSection sidebar={<StyledNav items={handyLinksItems} title="Handy links" />}>
            <H2 variant="marginBottomSpacer7">Contact us</H2>
            <H3>General enquiries</H3>
            <Row>
              <Col df={5} sm={12}>
                <div className={styles.generalEnquiry}>
                  <H5>
                    <a href={`tel:${CONTACT.PHONE.STANDARD}`}>
                      <Icon name="phone-circle" size="large" className={styles.icon} />
                      {CONTACT.PHONE.PRETTY}
                    </a>
                  </H5>
                  <span className={styles.contactTimes}>
                    {map(
                      (hours) => (
                        <P key={hours}>{hours}</P>
                      ),
                      CONTACT.CALL_CENTRE_HOURS,
                    )}
                  </span>
                </div>
              </Col>
              <Col df={7} sm={12}>
                <div className={styles.generalEnquiry}>
                  <a href={`mailto:${CONTACT.EMAIL}`}>
                    <Icon name="device-desktop" size="large" className={styles.icon} />
                    {CONTACT.EMAIL}
                  </a>
                </div>
              </Col>
            </Row>
            <Row>
              <Col df={5} sm={12}>
                <div className={styles.generalEnquiry}>
                  <H5>
                    <Icon name="envelope" size="large" className={styles.icon} />
                    Mail
                  </H5>
                  <span className={styles.address}>
                    <P>ahm travel insurance</P>
                    <P>c/o Travel Insurance Partners</P>
                    <P>PO Box 168</P>
                    <P>North Sydney NSW 2060</P>
                  </span>
                </div>
              </Col>
            </Row>
            <Row>
              <Col df={9} sm={12}>
                <H3>24 hour emergency assistance</H3>
                <P>
                  All policyholders have access to the emergency assistance team of doctors, nurses, travel agents and
                  case managers who are contactable 24 hours a day 7 days a week.
                </P>
                <P>
                  You can call Australia direct and toll free from the following countries. When you call please have
                  your policy number (it’s in the email you got when you purchased) and a contact number we can call you
                  back on if required.
                </P>
                {uncapFpIterator(map)(
                  // @ts-expect-error - Automatic, Please fix when editing this file
                  (emergencyContact, key) => (
                    <P key={key}>
                      <span className={styles.emergencyCountry}>{emergencyContact.COUNTRY}: </span>
                      {emergencyContact.PHONE}
                    </P>
                  ),
                  CONTACT.EMERGENCY,
                )}
                <P>Charges may apply if calling from a pay phone or mobile phone.</P>
                <P>
                  From all other countries or if you are experiencing difficulties with one of the numbers above please
                  call +61 (0) 2 8907 5662
                </P>
              </Col>
            </Row>
          </InsuranceSection>
        </Wrapper>
      </Section>

      <InsuranceSection>
        <Wrapper>
          <SmallDisclaimer />
        </Wrapper>
      </InsuranceSection>
    </LegacyBorderedWrapper>
  );
};

export default TravelInsuranceContactUs;
